import { backgroundOrange } from '@/theme/colors'
import Breadcrumbs from '@components/Breadcrumbs'
import { useAuth } from '@context/AuthContext'
import { useBreadcrumbContext } from '@context/BreadcrumbContext'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import Header from '../Header'

const LayoutContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	overflow: hidden;
`

const BreadcrumbWrapper = styled.div`
	background-color: ${backgroundOrange};
	padding: 0 1.5rem;
	flex-shrink: 0;
`

const ContentWrapper = styled.div`
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
`

interface LayoutProps {
	children: React.ReactNode
	showBackButton?: boolean
	backButtonText?: string
	onBackClick?: () => void
}

const Layout: React.FC<LayoutProps> = ({
	children,
	showBackButton = false,
	backButtonText = 'Back',
	onBackClick,
}) => {
	const navigate = useNavigate()
	const { logout } = useAuth()
	const { breadcrumbs } = useBreadcrumbContext()

	const handleLogout = () => {
		logout()
		navigate('/')
	}

	const handleBack = () => {
		if (onBackClick) {
			onBackClick()
		} else {
			navigate(-1) // Default: go back in browser history
		}
	}

	const handleMyTripsClick = () => {
		navigate('/trips')
	}

	const handleMyProfileClick = () => {
		navigate('/profile')
	}

	return (
		<LayoutContainer>
			<Header
				onLogout={handleLogout}
				showBackButton={showBackButton}
				onBackClick={handleBack}
				backButtonText={backButtonText}
				onMyTripsClick={handleMyTripsClick}
				onMyProfileClick={handleMyProfileClick}
			/>
			{breadcrumbs.length > 0 && (
				<BreadcrumbWrapper>
					<Breadcrumbs items={breadcrumbs} />
				</BreadcrumbWrapper>
			)}
			<ContentWrapper>
				{children}
			</ContentWrapper>
		</LayoutContainer>
	)
}

export default Layout
